/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { DocumentPublic } from './DocumentPublic'
import {
  DocumentPublicFromJSON,
  DocumentPublicFromJSONTyped,
  DocumentPublicToJSON,
} from './DocumentPublic'

/**
 *
 * @export
 * @interface PaginatedDocumentPublic
 */
export interface PaginatedDocumentPublic {
  /**
   *
   * @type {Array<DocumentPublic>}
   * @memberof PaginatedDocumentPublic
   */
  results: Array<DocumentPublic>
  /**
   *
   * @type {number}
   * @memberof PaginatedDocumentPublic
   */
  count: number
  /**
   *
   * @type {string}
   * @memberof PaginatedDocumentPublic
   */
  next: string | null
  /**
   *
   * @type {string}
   * @memberof PaginatedDocumentPublic
   */
  previous: string | null
}

/**
 * Check if a given object implements the PaginatedDocumentPublic interface.
 */
export function instanceOfPaginatedDocumentPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'results' in value
  isInstance = isInstance && 'count' in value
  isInstance = isInstance && 'next' in value
  isInstance = isInstance && 'previous' in value

  return isInstance
}

export function PaginatedDocumentPublicFromJSON(json: any): PaginatedDocumentPublic {
  return PaginatedDocumentPublicFromJSONTyped(json, false)
}

export function PaginatedDocumentPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedDocumentPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    results: (json['results'] as Array<any>).map(DocumentPublicFromJSON),
    count: json['count'],
    next: json['next'],
    previous: json['previous'],
  }
}

export function PaginatedDocumentPublicToJSON(value?: PaginatedDocumentPublic | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    results: (value.results as Array<any>).map(DocumentPublicToJSON),
    count: value.count,
    next: value.next,
    previous: value.previous,
  }
}
